<script setup>
import { useI18n } from 'vue-i18n'
import TitleComponent from "@/components/TitleComponent/index.vue"
const { t } = useI18n();
import { useRouter } from 'vue-router'
const router = useRouter()
const goBack = () => {
    router.go(-1);
}
const isMobile=ref(false);//false代表pc
onMounted(() => { 
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      console.log('Is mobile device:', isMobile.value);
})
</script>
<template>
<div class="container">
    <TitleComponent v-if="isMobile" :title="t('setup137')"></TitleComponent>

    <div class="packContent">
    <div class="title">
        {{ $t('setup137') }}
    </div>
   <div class="Headline">{{ $t('setup339') }}</div>
   <div class="Headline">{{ $t('setup340') }} alin19991207@51shopy.com {{ $t('setup436') }}</div>
   <div class="Headline">{{ $t('setup341') }}</div>
    <div class="Headline">{{ $t('setup342') }}</div>
   <div class="Headline">{{ $t('setup343') }}</div>
   <div class="Headline">{{ $t('setup344') }}</div>
 <div class="title">
        {{ $t('setup345') }}
    </div>
    <div class="Headline">{{ $t('setup346') }}</div>
    <div class="content">
        <div class="Subtitle-title">{{ $t('setup347') }}</div>
        <p class="Subtitle-content"> {{ $t('setup348') }}</p>
        <div class="table">
            <table width="100%" border="1"  cellspacing="0">
                <tbody>
                    <tr>
                        <th>{{ $t('setup349') }}</th>
                        <th>{{ $t('setup350') }}</th>
                        <th>{{ $t('setup351') }}</th>
                        <th></th>
                    </tr>
                    <tr>
                        <td rowspan="12" style="width: 210px;">{{ $t('setup352') }}</td>
                        <td>{{ $t('setup354') }}</td>
                        <td>{{ $t('setup355') }}</td>
                        <td rowspan="12" style="width: 210px;">{{ $t('setup353') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup356') }}</td>
                        <td>{{ $t('setup357') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup358') }}</td>
                        <td>{{ $t('setup359') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup360') }}</td>
                        <td>{{ $t('setup361') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup362') }}</td>
                        <td>{{ $t('setup362') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup363') }}</td>
                        <td>{{ $t('setup364') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup365') }}</td>
                        <td>{{ $t('setup366') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup367') }}</td>
                        <td>{{ $t('setup367') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup368') }}</td>
                        <td>{{ $t('setup369') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup370') }}</td>
                        <td>{{ $t('setup371') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup372') }}</td>
                        <td>{{ $t('setup373') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup374') }}</td>
                        <td>{{ $t('setup375') }}</td>
                    </tr>
                    <tr>
                        <td rowspan="12" style="width: 210px;">{{ $t('setup376') }}</td>
                        <td colspan="2" style="padding: 100px 0;">
                            <p>{{ $t('setup378') }}</p>
                            <p>{{ $t('setup379') }}</p>
                            <p>{{ $t('setup380') }}</p>
                            <p>{{ $t('setup381') }}</p>
                            <p style="font-weight: 700;">{{ $t('setup382') }}</p>
                        </td>
                        <td rowspan="12" style="width: 210px;">{{ $t('setup377') }}</td>
                    </tr>
                    </tbody>
            </table>
        </div>
    </div>
    <div class="title">
        {{ $t('setup383') }}
    </div>
    <div class="Headline">{{ $t('setup384') }}</div>
    <div class="title">
        {{ $t('setup385') }}
    </div>
    <div class="content">
        <div class="Subtitle-title">{{ $t('setup386') }}</div>
        <p class="Subtitle-content"> {{ $t('setup387') }}</p>
        <p class="Subtitle-content"> {{ $t('setup388') }}</p>
        <p class="Subtitle-content"> {{ $t('setup389') }}</p>
        <p class="Subtitle-content"> {{ $t('setup390') }}</p>
    </div>
    <div class="content">
        <div class="Subtitle-title">{{ $t('setup391') }}</div>
        <div class="table">
            <table width="100%" border="1"  cellspacing="0">
                    <tr>
                        <th>{{ $t('setup392') }}</th>
                        <th>{{ $t('setup393') }}</th>
                    </tr>
                    <tr>
                        <td>{{ $t('setup394') }}</td>
                        <td>{{ $t('setup395') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup396') }}</td>
                        <td>{{ $t('setup397') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup398') }}</td>
                        <td>{{ $t('setup399') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup400') }}</td>
                        <td>{{ $t('setup401') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup402') }}</td>
                        <td>{{ $t('setup401') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup403') }}</td>
                        <td>
                            <p>{{ $t('setup404') }}</p>
                            <p>{{ $t('setup405') }}</p>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup406') }}</td>
                        <td>{{ $t('setup407') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup408') }}</td>
                        <td>
                            <p>{{ $t('setup409') }}</p>
                            <p>{{ $t('setup410') }}</p>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup411') }}</td>
                        <td>{{ $t('setup412') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup413') }}</td>
                        <td>
                            <p>{{ $t('setup414') }}</p>
                            <p>{{ $t('setup415') }}</p>
                            <p>{{ $t('setup416') }}</p>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup417') }}</td>
                        <td>{{ $t('setup401') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup418') }}</td>
                        <td>{{ $t('setup401') }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup419') }}</td>
                        <td>
                            <p>{{ $t('setup420') }}</p>
                            <p>{{ $t('setup421') }}</p>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('setup422') }}</td>
                        <td>{{ $t('setup401') }}</td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <p>{{ $t('setup423') }}</p>
                            <p>{{ $t('setup424') }}</p>
                        </td>
                    </tr>
            </table>
        </div>
    </div>
    <div class="content">
        <div class="Subtitle-title">{{ $t('setup425') }}</div>
        <p class="Subtitle-content"> {{ $t('setup426') }}</p>
        <p class="Subtitle-content"> {{ $t('setup427') }}</p>
        <p class="Subtitle-content"> {{ $t('setup428') }}</p>
        <p class="Subtitle-content"> {{ $t('setup429') }}</p>
        <p class="Subtitle-content"> {{ $t('setup430') }}</p>
        <p class="Subtitle-content"> {{ $t('setup431') }}</p>
    </div>
</div>
</div>
</template>
<style scoped lang='scss'>
.container{
    width: 100%;
}
.title{
    // padding-top: 40px;
    color: #282828;
    font-weight: 700;
    font-size: 25px;
    padding-bottom: 16px;
}
.Headline {
    padding: 8px 0px;
    font-size: 18px;
    line-height: 30px;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
}
.Subtitle {
    font-size: 14px;
    line-height: 30px;
    // overflow: hidden;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
}
.content {
    padding: 45px 0;

    .Subtitle-title {
        font-weight: 700;
        font-size: 14px;
        line-height: 30px;
        overflow: hidden;
        color: #131926;
        font-family: Montserrat, Arial, sans-serif;
    }

    .Subtitle-content {
        font-size: 14px;
        line-height: 30px;
        overflow: hidden;
        color: #131926;
        font-family: Montserrat, Arial, sans-serif;

        span {
            font-weight: 700;
        }
    }
}
.table{
    padding-bottom: 50px;
    table{
        border-collapse: collapse;
        border: 2px solid black;
    }
    th{
        border: 1 solid;
        border-color: #131926;
        color: #169179;
        padding: 10px 5px; 
    }
    td{
        border-width:1px;
        border: 1 solid;
        border-color: #131926;
        text-align: center;
        padding: 8px 5px; 
    }
}
@media (max-width: 768px) {
    .container{
        width: 100%;
    }
    .content{
        padding-top: 0px;
    }
    .packContent{
        padding: 55px 20px 100px 20px;
        .title{
            display: none;
        }
    }
    .Headline{
    padding: 8px 0px;
    font-size: 16px;
    line-height: 30px;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
}
   
   
}
</style>